import { render } from "./ContactForm.vue?vue&type=template&id=94390878&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=94390878&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-94390878"

export default script